var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplainerBackgroundIcons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 603,
    viewBox: "0 0 318 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 570.054L285.029 575.68L304.202 594.853H285.024V602.809H317.784V570.047H309.828V589.227L290.656 570.054Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.779 534.962L312.153 529.335L292.98 548.508V529.33H285.024V562.09H317.785V554.134H298.607L317.779 534.962Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 515.741L290.656 521.368L309.829 502.195V521.373H317.785V488.613H285.024V496.569H304.202L285.03 515.741Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 575.68L271.434 570.053L252.262 589.227V570.047H244.305V602.809H277.067V594.852H257.888L277.061 575.68Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.937 529.336L244.312 534.962L263.484 554.135H244.305V562.091H277.066V529.33H269.11V548.509L249.937 529.336Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 494.244L271.434 488.618L252.262 507.791V488.613H244.305V521.373H277.067V513.417H257.888L277.061 494.244Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 570.054L203.595 575.68L222.767 594.853H203.589V602.809H236.349V570.047H228.393V589.227L209.22 570.054Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 529.336L203.595 534.962L222.767 554.135H203.589V562.091H236.349V529.33H228.393V548.509L209.22 529.336Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 488.618L203.595 494.245L222.767 513.417H203.589V521.374H236.349V488.612H228.393V507.791L209.22 488.618Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 570.054L122.158 575.68L141.331 594.853H122.153V602.809H154.913V570.047H146.957V589.227L127.785 570.054Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.159 556.459L127.785 562.085L146.957 542.912V562.091H154.913V529.33H122.153V537.287H141.331L122.159 556.459Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 521.367L154.907 515.741L135.735 496.568H154.913V488.613H122.153V521.373H130.109V502.195L149.282 521.367Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 597.177L87.0678 602.802L106.24 583.63V602.809H114.197V570.047H81.436V578.004H100.615L81.4422 597.177Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 529.336L81.4414 534.962L100.615 554.135H81.436V562.091H114.197V529.33H106.24V548.509L87.0678 529.336Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 521.367L114.19 515.741L95.018 496.568H114.197V488.613H81.436V521.373H89.3924V502.195L108.565 521.367Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 570.054L40.7231 575.68L59.8963 594.853H40.7178V602.809H73.4783V570.047H65.5219V589.227L46.3496 570.054Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 529.336L40.7231 534.962L59.8963 554.135H40.7178V562.091H73.4783V529.33H65.5219V548.509L46.3496 529.336Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 521.367L73.4729 515.741L54.2998 496.568H73.4783V488.613H40.7178V521.373H48.6741V502.195L67.8465 521.367Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7608 594.851L13.5815 594.851L32.7539 575.679L27.1274 570.053L7.9551 589.226L7.9551 570.047L-0.000488281 570.047L-0.000489713 602.808L32.7608 602.808L32.7608 594.851Z",
    fill: "#FFDF03"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8039 529.33V548.508L5.63154 529.336L0.00512968 534.962L19.1782 554.135H-0.000244141V562.091H32.7602V529.33H24.8039Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 488.612V521.373H32.7602V513.416H13.5818L32.7541 494.244L27.1292 488.617L7.95535 507.791V488.612H-0.000244141Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 570.054L162.877 575.68L182.049 594.853H162.871V602.809H195.631V570.047H187.675V589.227L168.503 570.054Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 556.459L168.503 562.085L187.675 542.912V562.091H195.631V529.33H162.871V537.287H182.049L162.877 556.459Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 488.618L162.877 494.245L182.049 513.417H162.871V521.374H195.631V488.612H187.675V507.791L168.503 488.618Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 475.023L290.656 480.65L309.829 461.477V480.655H317.785V447.895H285.024V455.851H304.202L285.03 475.023Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 453.527L271.434 447.9L252.262 467.073V447.895H244.305V480.655H277.067V472.699H257.888L277.061 453.527Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 447.901L203.595 453.526L222.767 472.699H203.589V480.656H236.349V447.895H228.393V467.073L209.22 447.901Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 447.901L122.158 453.526L141.331 472.699H122.153V480.656H154.913V447.895H146.957V467.073L127.785 447.901Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 480.649L114.19 475.023L95.018 455.85H114.197V447.894H81.436V480.655H89.3924V461.477L108.565 480.649Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 475.023L46.3496 480.65L65.5227 461.477V480.655H73.479V447.895H40.7178V455.851H59.8963L40.7239 475.023Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 447.895V480.655H7.95611V461.477L27.1292 480.649L32.7549 475.023L13.5825 455.851H32.7602V447.895H-0.000244141Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 447.901L162.877 453.526L182.049 472.699H162.871V480.656H195.631V447.895H187.675V467.073L168.503 447.901Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M317.779 412.809L312.153 407.182L292.98 426.355V407.177H285.024V439.938H317.785V431.981H298.607L317.779 412.809Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 439.931L277.061 434.306L257.887 415.133H277.066V407.176H244.305V439.938H252.262V420.759L271.434 439.931Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M236.343 412.809L230.717 407.182L211.545 426.355V407.177H203.589V439.938H236.349V431.981H217.171L236.343 412.809Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 439.931L154.907 434.306L135.735 415.133H154.913V407.176H122.153V439.938H130.109V420.759L149.282 439.931Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 434.306L87.0678 439.932L106.24 420.759V439.938H114.197V407.177H81.436V415.133H100.615L81.4422 434.306Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 434.306L46.3496 439.932L65.5227 420.759V439.938H73.479V407.177H40.7178V415.133H59.8963L40.7239 434.306Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 407.177V439.938H7.95611V420.759L27.1292 439.931L32.7549 434.306L13.5825 415.133H32.7602V407.177H-0.000244141Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 407.183L162.877 412.809L182.049 431.982H162.871V439.938H195.631V407.177H187.675V426.355L168.503 407.183Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 393.588L290.656 399.214L309.829 380.041V399.22H317.785V366.459H285.024V374.416H304.202L285.03 393.588Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 372.091L271.434 366.465L252.262 385.637V366.459H244.305V399.219H277.067V391.263H257.888L277.061 372.091Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 366.465L203.595 372.091L222.767 391.264H203.589V399.22H236.349V366.459H228.393V385.638L209.22 366.465Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 399.214L154.907 393.587L135.735 374.415H154.913V366.458H122.153V399.22H130.109V380.041L149.282 399.214Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 399.214L114.19 393.587L95.018 374.415H114.197V366.458H81.436V399.22H89.3924V380.041L108.565 399.214Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 393.588L46.3496 399.214L65.5227 380.041V399.22H73.479V366.459H40.7178V374.416H59.8963L40.7239 393.588Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 366.459V399.22H7.95611V380.041L27.1292 399.214L32.7549 393.588L13.5825 374.416H32.7602V366.459H-0.000244141Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 372.091L190 366.465L170.827 385.637V366.459H162.871V399.219H195.631V391.263H176.453L195.625 372.091Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 325.748L285.029 331.373L304.202 350.546H285.024V358.502H317.784V325.741H309.828V344.92L290.656 325.748Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 358.496L277.061 352.87L257.887 333.698H277.066V325.741H244.305V358.502H252.262V339.323L271.434 358.496Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.717 358.496L236.344 352.87L217.171 333.698H236.349V325.741H203.589V358.502H211.545V339.323L230.717 358.496Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 358.496L154.907 352.87L135.735 333.698H154.913V325.741H122.153V358.502H130.109V339.323L149.282 358.496Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 352.87L87.0678 358.497L106.24 339.323V358.502H114.197V325.741H81.436V333.698H100.615L81.4422 352.87Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 358.496L73.4729 352.87L54.2998 333.698H73.4783V325.741H40.7178V358.502H48.6741V339.323L67.8465 358.496Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 325.741V358.502H32.7602V350.545H13.5818L32.7541 331.373L27.1292 325.747L7.95535 344.919V325.741H-0.000244141Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.503 325.748L162.877 331.373L182.049 350.546H162.871V358.502H195.631V325.741H187.675V344.92L168.503 325.748Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 -0.000228882V7.95613H19.1782L0.00589739 27.1292L5.63154 32.7549L24.8046 13.5818V32.7603H32.7602V-0.000228882H-0.000244141Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 40.7175V73.478H7.95611V54.2995L27.1292 73.4719L32.7549 67.847L13.5825 48.6739H32.7602V40.7175H-0.000244141Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8039 81.435V100.614L5.63154 81.4419L0.00512968 87.0676L19.1782 106.241H-0.000244141V114.196H32.7602V81.435H24.8039Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 122.153V154.914H7.95611V135.735L27.1292 154.907L32.7549 149.283L13.5825 130.109H32.7602V122.153H-0.000244141Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 27.129L46.3496 32.7554L65.5227 13.5823V32.7607H73.479V0.000259399H40.7178V7.95662H59.8963L40.7239 27.129Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 73.4724L73.4729 67.8467L54.2998 48.6736H73.4783V40.7173H40.7178V73.4785H48.6741V54.3L67.8465 73.4724Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4717 87.0671L67.846 81.4407L48.6729 100.614V81.4353H40.7166V114.196H73.4778V106.239H54.2993L73.4717 87.0671Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 154.907L73.4729 149.282L54.2998 130.109H73.4783V122.152H40.7178V154.914H48.6741V135.735L67.8465 154.907Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 27.129L87.0678 32.7554L106.24 13.5823V32.7607H114.197V0.000259399H81.436V7.95662H100.615L81.4422 27.129Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 40.7237L81.4414 46.3493L100.615 65.5224H81.436V73.478H114.197V40.7175H106.24V59.896L87.0678 40.7237Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 114.19L114.19 108.564L95.018 89.3909H114.197V81.4346H81.436V114.196H89.3924V95.0173L108.565 114.19Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 122.159L81.4414 127.785L100.615 146.958H81.436V154.915H114.197V122.153H106.24V141.332L87.0678 122.159Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M122.159 27.129L127.785 32.7554L146.957 13.5823V32.7607H154.913V0.000259399H122.153V7.95662H141.331L122.159 27.129Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 73.4724L154.907 67.8467L135.735 48.6736H154.913V40.7173H122.153V73.4785H130.109V54.3L149.282 73.4724Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 114.19L154.907 108.564L135.735 89.3909H154.913V81.4346H122.153V114.196H130.109V95.0173L149.282 114.19Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 154.907L154.907 149.282L135.735 130.109H154.913V122.152H122.153V154.914H130.109V135.735L149.282 154.907Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 27.129L168.503 32.7554L187.675 13.5823V32.7607H195.631V0.000259399H162.871V7.95662H182.049L162.877 27.129Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M190 73.4724L195.625 67.8467L176.453 48.6736H195.631V40.7173H162.871V73.4785H170.827V54.3L190 73.4724Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 108.564L168.503 114.19L187.675 95.0173V114.196H195.631V81.4353H162.871V89.3917H182.049L162.877 108.564Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 127.785L190 122.158L170.827 141.332V122.153H162.871V154.914H195.631V146.957H176.453L195.625 127.785Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M236.343 5.63156L230.717 0.00591278L211.545 19.1782V-0.000228882H203.589V32.7603H236.349V24.8039H217.171L236.343 5.63156Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M203.595 67.8467L209.22 73.4731L228.393 54.3V73.4785H236.349V40.718H203.589V48.6744H222.767L203.595 67.8467Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M230.717 114.19L236.344 108.564L217.171 89.3909H236.349V81.4346H203.589V114.196H211.545V95.0173L230.717 114.19Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M203.595 149.282L209.22 154.908L228.393 135.735V154.914H236.349V122.153H203.589V130.109H222.767L203.595 149.282Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M244.312 27.129L249.937 32.7554L269.11 13.5823V32.7607H277.066V0.000259399H244.305V7.95662H263.484L244.312 27.129Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 73.4724L277.061 67.8467L257.887 48.6736H277.066V40.7173H244.305V73.4785H252.262V54.3L271.434 73.4724Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 114.19L277.061 108.564L257.887 89.3909H277.066V81.4346H244.305V114.196H252.262V95.0173L271.434 114.19Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 154.907L277.061 149.282L257.887 130.109H277.066V122.152H244.305V154.914H252.262V135.735L271.434 154.907Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 27.129L290.656 32.7554L309.829 13.5823V32.7607H317.784V0.000259399H285.024V7.95662H304.202L285.03 27.129Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 73.4724L317.779 67.8467L298.606 48.6736H317.784V40.7173H285.024V73.4785H292.98V54.3L312.153 73.4724Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M317.779 87.0671L312.153 81.4407L292.98 100.614V81.4353H285.024V114.196H317.785V106.239H298.607L317.779 87.0671Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 154.907L317.779 149.282L298.606 130.109H317.784V122.152H285.024V154.914H292.98V135.735L312.153 154.907Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 162.87V170.827H19.1782L0.00589739 190L5.63154 195.625L24.8046 176.453V195.631H32.7602V162.87H-0.000244141Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 195.625L73.4729 190L54.2998 170.827H73.4783V162.871H40.7178V195.631H48.6741V176.453L67.8465 195.625Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.19 168.503L108.565 162.876L89.3924 182.049V162.871H81.436V195.631H114.197V187.675H95.018L114.19 168.503Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 195.625L154.907 190L135.735 170.827H154.913V162.871H122.153V195.631H130.109V176.453L149.282 195.625Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 168.503L190 162.876L170.827 182.049V162.871H162.871V195.631H195.631V187.675H176.453L195.625 168.503Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M203.595 190L209.22 195.625L228.393 176.453V195.631H236.349V162.871H203.589V170.827H222.767L203.595 190Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 195.625L277.061 190L257.887 170.827H277.066V162.871H244.305V195.631H252.262V176.453L271.434 195.625Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 195.625L317.779 190L298.606 170.827H317.784V162.871H285.024V195.631H292.98V176.453L312.153 195.625Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 203.589V236.349H7.95611V217.17L27.1292 236.342L32.7549 230.717L13.5825 211.545H32.7602V203.589H-0.000244141Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 236.342L73.4729 230.717L54.2998 211.545H73.4783V203.588H40.7178V236.349H48.6741V217.17L67.8465 236.342Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 203.595L81.4414 209.22L100.615 228.393H81.436V236.349H114.197V203.589H106.24V222.767L87.0678 203.595Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 236.342L154.907 230.717L135.735 211.545H154.913V203.588H122.153V236.349H130.109V217.17L149.282 236.342Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 230.717L168.503 236.343L187.675 217.171V236.349H195.631V203.589H162.871V211.545H182.049L162.877 230.717Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 203.595L203.595 209.22L222.767 228.393H203.589V236.349H236.349V203.589H228.393V222.767L209.22 203.595Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M244.312 230.717L249.937 236.343L269.11 217.171V236.349H277.066V203.589H244.305V211.545H263.484L244.312 230.717Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 236.342L317.779 230.717L298.606 211.545H317.784V203.588H285.024V236.349H292.98V217.17L312.153 236.342Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 244.306V252.262H19.1782L0.00589739 271.435L5.63154 277.06L24.8046 257.888V277.066H32.7602V244.306H-0.000244141Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 271.435L46.3496 277.061L65.5227 257.888V277.067H73.479V244.306H40.7178V252.263H59.8963L40.7239 271.435Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M114.19 249.938L108.565 244.311L89.3924 263.484V244.306H81.436V277.066H114.197V269.11H95.018L114.19 249.938Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M122.159 271.435L127.785 277.061L146.957 257.888V277.067H154.913V244.306H122.153V252.263H141.331L122.159 271.435Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 249.938L190 244.311L170.827 263.484V244.306H162.871V277.066H195.631V269.11H176.453L195.625 249.938Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M203.595 271.435L209.22 277.061L228.393 257.888V277.067H236.349V244.306H203.589V252.263H222.767L203.595 271.435Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 277.06L277.061 271.435L257.887 252.262H277.066V244.306H244.305V277.066H252.262V257.888L271.434 277.06Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 271.435L290.656 277.061L309.829 257.888V277.067H317.784V244.306H285.024V252.263H304.202L285.03 271.435Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 285.024V292.981H19.1782L0.00589739 312.153L5.63154 317.779L24.8046 298.606V317.784H32.7602V285.024H-0.000244141Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 317.778L73.4729 312.152L54.2998 292.98H73.4783V285.024H40.7178V317.784H48.6741V298.606L67.8465 317.778Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 285.03L81.4414 290.655L100.615 309.828H81.436V317.784H114.197V285.024H106.24V304.202L87.0678 285.03Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 317.778L154.907 312.152L135.735 292.98H154.913V285.024H122.153V317.784H130.109V298.606L149.282 317.778Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M190 317.778L195.625 312.152L176.453 292.98H195.631V285.024H162.871V317.784H170.827V298.606L190 317.778Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M209.22 285.03L203.595 290.655L222.767 309.828H203.589V317.784H236.349V285.024H228.393V304.202L209.22 285.03Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M249.937 285.03L244.312 290.655L263.484 309.828H244.305V317.784H277.066V285.024H269.11V304.202L249.937 285.03Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 317.778L317.779 312.152L298.606 292.98H317.784V285.024H285.024V317.784H292.98V298.606L312.153 317.778Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerBackgroundIcons);
export default __webpack_public_path__ + "static/media/explainer-background-icons.dfd0b444be5e70ad0977ee7c47416a76.svg";
export { ForwardRef as ReactComponent };